"use client";
import * as React from "react";
const SvgSortRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.89 11.5h3.55c.5 0 .9-.41.9-.92s-.4-.91-.9-.91H.9a.9.9 0 0 0-.89.91c0 .5.4.92.89.92M0 1.42c0 .5.4.91.89.91H15.1a.9.9 0 0 0 .89-.91.9.9 0 0 0-.89-.92H.89a.9.9 0 0 0-.89.92m.89 5.5h8.89c.49 0 .89-.42.89-.92s-.4-.92-.9-.92H.9c-.5 0-.9.42-.9.92s.4.92.89.92" }));
export {
  SvgSortRound as default
};
